import { render, staticRenderFns } from "./homeSmallCard.vue?vue&type=template&id=68fd3554&scoped=true"
import script from "./homeSmallCard.vue?vue&type=script&lang=ts"
export * from "./homeSmallCard.vue?vue&type=script&lang=ts"
import style0 from "./homeSmallCard.vue?vue&type=style&index=0&id=68fd3554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd3554",
  null
  
)

export default component.exports